import SingleLayerDropdown from "../singleILayerDropdown/SingleLayerDropdown";
import MultiLayerDropdown from "../multiLayerDropdown/MultiLayerDropdown";
import "./LayersComponent.css"
import MixedLayerDropdown from "../mixedLayerDropdown/MixedLayerDropdown";
const LayersComponent = ({
  opacities,
  onHandleOpacity,
  layers,
  iconClass,
   type,
}) => {
  return (
    <div data-testid={`layers-list-${type}`}>
      {layers.map((layer, index) => {
        if (layer.type === "single") {
          return (
            <SingleLayerDropdown
              key={layer.id}
              description={layer.description}
              title={layer.title}
              items={layer.items}
              opacities={opacities}
              onHandleOpacity={onHandleOpacity}
              iconClass={layer.iconClass}
              panelType={layer.type}
            />
          );
        }

        if (layer.type === "multi") {
         
          return (
            <MultiLayerDropdown
              key={layer.id}
              description={layer.description}
              title={layer.title}
              items={layer.items}
              subcategories={layer.subcategories}
              opacities={opacities}
              onHandleOpacity={onHandleOpacity}
              iconClass={layer.iconClass}
              panelType={layer.type}

            />
          );
        }
        if (layer.type === "mixed") {
         
          return (
            <MixedLayerDropdown
              key={layer.id}
              description={layer.description}
              title={layer.title}
              items={layer.items}
              subcategories={layer.subcategories}
              opacities={opacities}
              onHandleOpacity={onHandleOpacity}
              iconClass={layer.iconClass}
              panelType={layer.type}

            />
          );
        }
      })}
      
    </div>
  );
};

export default LayersComponent;
